<template>
    <div class="flex items-center gap-4 w-full overflow-hidden">
        <div>
            <button
                ref="previous"
                class="inline-flex justify-center items-center bg-green rounded-full p-2 disabled:opacity-50 disabled:cursor-not-allowed">
                <ChevronLeftIcon class="w-6 h-6"/>
            </button>
        </div>
        <div class="flex-1 overflow-hidden">
            <div v-if="courses && courses.length" ref="carousel" class="flex gap-4">
                <div
                    v-for="course in courses"
                    ref="courses"
                >
                    <div class="bg-teal-dark h-full flex flex-col justify-between">
                        <div class="bg-gray-200 w-full h-24 sm:h-48">
                            <Image
                                v-if="course.main_image && course.main_image.url"
                                :url="course.main_image.url"
                                :alt="course.title"
                                class="w-full h-full object-cover"/>
                        </div>
                        <div class="flex flex-col flex-1 py-6 px-6 text-white sm:px-10">
                            <h3 class="text-lg sm:text-2xl font-bold mb-auto">{{ course.title }}</h3>
                            <div class="mt-8">
                                <AppLink :to="{name: 'course', params: {courseId: course.id}}" theme="primary-button">
                                    Find our more
                                </AppLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <button ref="next"
                    class="inline-flex justify-center items-center bg-green rounded-full p-2 disabled:opacity-50 disabled:cursor-not-allowed">
                <ChevronRightIcon class="w-6 h-6"/>
            </button>
        </div>
    </div>
</template>

<script>

import {tns} from 'tiny-slider/src/tiny-slider';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/outline';
import Image from "@/Components/Image"
import AppLink from "@/Components/AppLink"

let slider;
export default {

    name: "CourseCarousel",

    props: {
        courses: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            info: {}
        };
    },

    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
        Image,
        AppLink
    },

    mounted() {
        if (this.courses && this.courses.length) {
            this.$nextTick(this.init)
        }
    },

    methods: {
        init() {
            slider = tns({
                container: this.$refs.carousel,
                items: 1,
                loop: false,
                mouseDrag: true,
                swipeAngle: false,
                prevButton: this.$refs.previous,
                nextButton: this.$refs.next,
                nav: false,
                responsive: {
                    "768": {
                        "items": 2,
                    },
                    "1024": {
                        "items": 3
                    }
                },
            })
        },
        destroy() {
            slider && slider.destroy();
        },
    },

    watch: {
        courses() {
            this.$nextTick(() => this.init());
        },
    },

    beforeUnmount() {
        this.destroy();
    }
};

</script>
